import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import {
  Alert,
  Box,
  Chip,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { ossChipSx } from "../common/ossChipStyles";

export const OssUploadResultPanel = ({ result }) => {
  if (!result) return null;

  const errorsByRow = (result.errors || []).reduce((acc, error) => {
    const key = error.rowNo || "-";
    if (!acc[key]) acc[key] = [];
    acc[key].push(error);
    return acc;
  }, {});

  return (
    <Box sx={{ p: 2, border: "1px solid #e5e7eb", borderRadius: "8px", bgcolor: "#fff" }}>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
        <Chip
          icon={result.failureCount ? <ErrorOutlineRoundedIcon /> : <CheckCircleOutlineRoundedIcon />}
          label={result.status}
          variant="outlined"
          sx={ossChipSx(
            result.failureCount
              ? { tone: "#b45309", bg: "#fff7ed", strong: true }
              : { tone: "#14b8a6", bg: "#ecfeff", strong: true }
          )}
        />
        <Typography sx={{ fontSize: 13, color: "#64748b" }}>
          전체 {result.totalCount}행 · 성공 {result.successCount}행 · 실패 {result.failureCount}행
        </Typography>
      </Stack>

      {(result.importedOrders || []).length > 0 && (
        <Box sx={{ mt: 1.4 }}>
          <Typography sx={{ fontSize: 14.5, fontWeight: 800, color: "#111827" }}>
            등록된 주문
          </Typography>
          <Stack spacing={0.7} sx={{ mt: 0.8 }}>
            {result.importedOrders.map((order) => (
              <Box
                key={order.orderId}
                sx={{
                  px: 1.1,
                  py: 0.9,
                  border: "1px solid #dcfce7",
                  borderRadius: "8px",
                  bgcolor: "#f0fdf4",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 1,
                }}
              >
                <Typography sx={{ fontSize: 13.5, fontWeight: 700, color: "#166534" }}>
                  {order.orderNo}
                </Typography>
                <Typography sx={{ fontSize: 12.5, color: "#166534" }}>
                  {order.lineCount}품목 · 행 {order.rowNos?.join(", ")}
                </Typography>
              </Box>
            ))}
          </Stack>
        </Box>
      )}

      {Object.keys(errorsByRow).length > 0 && (
        <Box sx={{ mt: 1.5 }}>
          <Divider sx={{ mb: 1.2 }} />
          <Typography sx={{ fontSize: 14.5, fontWeight: 800, color: "#111827" }}>
            행별 검증 오류
          </Typography>
          <Stack spacing={0.8} sx={{ mt: 0.8, maxHeight: 220, overflow: "auto", pr: 0.5 }}>
            {Object.entries(errorsByRow).map(([rowNo, errors]) => (
              <Alert key={rowNo} severity="error" sx={{ alignItems: "flex-start" }}>
                <Typography sx={{ fontSize: 13.5, fontWeight: 800 }}>
                  {rowNo}행
                </Typography>
                <Stack spacing={0.3} sx={{ mt: 0.4 }}>
                  {errors.map((error) => (
                    <Typography key={error.importErrorId || `${rowNo}-${error.fieldName}-${error.errorCode}`} sx={{ fontSize: 12.5 }}>
                      {error.fieldName || "필드"}: {error.errorMessage}
                      {error.inputValue ? ` (${error.inputValue})` : ""}
                    </Typography>
                  ))}
                </Stack>
              </Alert>
            ))}
          </Stack>
        </Box>
      )}
    </Box>
  );
};
